import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'LocalScenery',
    column_type: 'id',
  },
  created_at: {
    model_name: 'LocalScenery',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'LocalScenery',
    column_type: 'datetime',
  },
  appid: {
    model_name: 'LocalScenery',
    column_type: 'string',
  },
  name: {
    model_name: 'LocalScenery',
    column_type: 'string',
  },
  path: {
    model_name: 'LocalScenery',
    column_type: 'string',
  },
  env_version: {
    model_name: 'LocalScenery',
    column_type: 'enum',
  },
  jump_page_type: {
    model_name: 'LocalScenery',
    column_type: 'enum',
  },
  position: {
    model_name: 'LocalScenery',
    column_type: 'integer',
  },
  cover: {
    model_name: 'LocalScenery',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  content: {
    model_name: 'LocalScenery',
    column_type: 'text',
  },
  stations: {
    model_name: 'LocalScenery',
    column_type: 'has_many',
    extra: {
      association_name: 'stations',
      model_name: 'Station',
      foreign_key: 'station_id',
    },
  },
  station_ids: {
    model_name: 'LocalScenery',
    column_type: 'has_many',
    extra: {
      association_name: 'stations',
      model_name: 'Station',
      foreign_key: 'station_id',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
